export default "__VITE_ASSET__D5ddC$qq__";